import { useEffect, useState } from "react";
import { getAllRadiusNas } from "../../api/radius";

export function useAllNasHooks({ filter }) {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({count: 0, page: 1, pageSize: 10});
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const getAllNas = async (filter = {}) => {
    setLoading(true);
    setErrorMsg('')
    try {
      const { data } = await getAllRadiusNas({ ...filter });
      setData(data.data);
      setMeta(data.pagination);
    } catch (error) {
      if (error.response) {
        let { data } =  error.response;
        setErrorMsg(data.message)
      } else {
        setErrorMsg("Something Error Happened")
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    getAllNas(filter)
  }, [filter])

  return {
    data,
    meta,
    loading,
    errorMsg,
    getAllNas
  }
}